
// アンケートの質問形式（mst_surveys.input_type）
const SURVEY_INPUT_TYPE = {
  TEXT: 1, // フリーテキスト（テキストエリア）
  DROPDOWN: 2, // ドロップダウン（単一選択）
  CHECKBOX: 3, // チェックボックス（複数選択）
  RADIO: 4, // ラジオボタン（単一選択）
};

// 表示ラベル
const SURVEY_INPUT_TYPE_TEXTS = {
  [SURVEY_INPUT_TYPE.TEXT]: 'フリーテキスト',
  [SURVEY_INPUT_TYPE.DROPDOWN]: 'ドロップダウン',
  [SURVEY_INPUT_TYPE.CHECKBOX]: 'チェックボックス',
  [SURVEY_INPUT_TYPE.RADIO]: 'ラジオボタン',
};

// 選択肢を持つ形式（dropdown/checkbox/radio）
const SURVEY_HAS_OPTIONS = [
  SURVEY_INPUT_TYPE.DROPDOWN,
  SURVEY_INPUT_TYPE.CHECKBOX,
  SURVEY_INPUT_TYPE.RADIO,
];

// 単一選択（dropdown/radio）
const SURVEY_SINGLE_SELECT = [
  SURVEY_INPUT_TYPE.DROPDOWN,
  SURVEY_INPUT_TYPE.RADIO,
];

// 複数選択（checkbox）
const SURVEY_MULTI_SELECT = [
  SURVEY_INPUT_TYPE.CHECKBOX,
];

export default {
  SURVEY_INPUT_TYPE,
  SURVEY_INPUT_TYPE_TEXTS,
  SURVEY_HAS_OPTIONS,
  SURVEY_SINGLE_SELECT,
  SURVEY_MULTI_SELECT,
};
